import { RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ErrorFlashCardProps {
  retry: () => void;
}
const ErrorFlashCard = ({ retry }: ErrorFlashCardProps) => {
  return (
    <div className="h-[300px] md:h-[400px] w-full bg-white p-6 rounded-lg shadow-md grid place-items-center">
      <div className="flex flex-col items-center gap-4">
        <p className="text-destructive">
          Error loading questions. Please try again.
        </p>
        <Button variant="outline" onClick={retry}>
          <RefreshCcw className="mr-2 h-4 w-4" /> Retry
        </Button>
      </div>
    </div>
  );
};

export default ErrorFlashCard;
